export const DialogNames = [
  "help",
  "contact",
  "about",
  "workspaces",
  "feedback",
  "privacy",
  "terms",
];
export type DialogName = (typeof DialogNames)[number];

export type Route = {
  isRoot: boolean;
  dialog?: DialogName | null;
};
